/**
 * <DateRangePickerField
 *	/>
 *
 * A custom wrapper for SingleDatePicker
 *
 * @parent anybody
 * @stateful
 */
import 'react-dates/initialize';
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker, isInclusivelyBeforeDay } from 'react-dates';
import moment from 'moment';

import './DateRangePicker.scss';

import { DATE_FORMAT } from '../../constants';

export function daterange(props) {

  return (
    <DateRangePickerField
      {...props}
      onChange={({startDate, endDate})=> {
        if (startDate && endDate) {
          props.onChange(startDate.format(DATE_FORMAT) + ':::' + endDate.format(DATE_FORMAT));
        }
      }}
    />
  );
}

class DateRangePickerField extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);

    let dates
    if(typeof props.value !== 'string'){
      this.state = {}
    } else if (props.value != 'undefined:::undefined'){
      dates = props.value.split(':::');
      this.state = {
        startDate: moment(dates[0], 'YYYY-MM-DD') || moment(),
      }
    } else {
      this.state = {}
    }
    this.onDatesChange = this.onDatesChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    //
    // When we receive props.value, it is in string form
    // 'YYYY-MM-DD:::YYYY-MM-DD'
    //
    // So we're going to parse it into moment instances.
    //
    if (typeof nextProps.value === 'string') {
      let dates = nextProps.value.split(':::');
      this.setState({
        startDate: moment(dates[0], 'YYYY-MM-DD'),
        endDate: moment(dates[1], 'YYYY-MM-DD'),
      });
    }

    //
    // when props receive startDate and endDate, we assume they are instance of moment
    //
    if (nextProps.startDate) {
      this.setState({
        startDate: nextProps.startDate,
      });
    }

    if (nextProps.endDate) {
      this.setState({
        endDate: nextProps.endDate,
      });
    }

  }

  onDatesChange(opts) {
    const {
      startDate,
      endDate,
    } = opts;

    let {
      onChange,
    } = this.props;

    this.setState({ startDate, endDate }, ()=>{
      onChange(opts);
    })
  }

  render() {
    let {
      options,
      displayFormat,
    } = this.props;

    if (options) {
      delete options.enumOptions;
      delete options.isOutsideRange;
    }

    let {
      startDate,
      endDate,
      focusedInput,
    } = this.state;

    const hasValue = startDate && endDate;
    return (
      <div className={classnames('date-range-picker', 'form-input', {'has-value': hasValue})}>
        <DateRangePicker
          small={true}
          displayFormat={displayFormat || DATE_FORMAT}
          startDate={startDate} // momentPropTypes.momentObj or null,
          startDateId="start_date" // PropTypes.string.isRequired,

          startDatePlaceholderText={__('Start Date', 'DateRange')}
          endDatePlaceholderText={__('End Date', 'DateRange')}

          endDate={endDate} // momentPropTypes.momentObj or null,
          endDateId="end_date" // PropTypes.string.isRequired,

          onDatesChange={this.onDatesChange} // PropTypes.func.isRequired,
          focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
          onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
          minimumNights={0} // THIS allow selecting a same date
          showClearDates={true}
          isOutsideRange={ this.props.isOutsideRange? this.props.isOutsideRange :()=> false}
          {...options}
        />

      </div>
    )
  }
}

export default DateRangePickerField;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/DateRangePicker/index.js